"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decodeXMLStrict = exports.decodeHTML5Strict = exports.decodeHTML4Strict = exports.decodeHTML5 = exports.decodeHTML4 = exports.decodeHTMLAttribute = exports.decodeHTMLStrict = exports.decodeHTML = exports.decodeXML = exports.DecodingMode = exports.EntityDecoder = exports.encodeHTML5 = exports.encodeHTML4 = exports.encodeNonAsciiHTML = exports.encodeHTML = exports.escapeText = exports.escapeAttribute = exports.escapeUTF8 = exports.escape = exports.encodeXML = exports.encode = exports.decodeStrict = exports.decode = exports.EncodingMode = exports.EntityLevel = void 0;

var decode_js_1 = require("./decode.js");

var encode_js_1 = require("./encode.js");

var escape_js_1 = require("./escape.js");
/** The level of entities to support. */


var EntityLevel;

(function (EntityLevel) {
  /** Support only XML entities. */
  EntityLevel[EntityLevel["XML"] = 0] = "XML";
  /** Support HTML entities, which are a superset of XML entities. */

  EntityLevel[EntityLevel["HTML"] = 1] = "HTML";
})(EntityLevel = exports.EntityLevel || (exports.EntityLevel = {}));

var EncodingMode;

(function (EncodingMode) {
  /**
   * The output is UTF-8 encoded. Only characters that need escaping within
   * XML will be escaped.
   */
  EncodingMode[EncodingMode["UTF8"] = 0] = "UTF8";
  /**
   * The output consists only of ASCII characters. Characters that need
   * escaping within HTML, and characters that aren't ASCII characters will
   * be escaped.
   */

  EncodingMode[EncodingMode["ASCII"] = 1] = "ASCII";
  /**
   * Encode all characters that have an equivalent entity, as well as all
   * characters that are not ASCII characters.
   */

  EncodingMode[EncodingMode["Extensive"] = 2] = "Extensive";
  /**
   * Encode all characters that have to be escaped in HTML attributes,
   * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
   */

  EncodingMode[EncodingMode["Attribute"] = 3] = "Attribute";
  /**
   * Encode all characters that have to be escaped in HTML text,
   * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
   */

  EncodingMode[EncodingMode["Text"] = 4] = "Text";
})(EncodingMode = exports.EncodingMode || (exports.EncodingMode = {}));
/**
 * Decodes a string with entities.
 *
 * @param data String to decode.
 * @param options Decoding options.
 */


function decode(data, options) {
  if (options === void 0) {
    options = EntityLevel.XML;
  }

  var level = typeof options === "number" ? options : options.level;

  if (level === EntityLevel.HTML) {
    var mode = _typeof(options) === "object" ? options.mode : undefined;
    return (0, decode_js_1.decodeHTML)(data, mode);
  }

  return (0, decode_js_1.decodeXML)(data);
}

exports.decode = decode;
/**
 * Decodes a string with entities. Does not allow missing trailing semicolons for entities.
 *
 * @param data String to decode.
 * @param options Decoding options.
 * @deprecated Use `decode` with the `mode` set to `Strict`.
 */

function decodeStrict(data, options) {
  var _a;

  if (options === void 0) {
    options = EntityLevel.XML;
  }

  var opts = typeof options === "number" ? {
    level: options
  } : options;
  (_a = opts.mode) !== null && _a !== void 0 ? _a : opts.mode = decode_js_1.DecodingMode.Strict;
  return decode(data, opts);
}

exports.decodeStrict = decodeStrict;
/**
 * Encodes a string with entities.
 *
 * @param data String to encode.
 * @param options Encoding options.
 */

function encode(data, options) {
  if (options === void 0) {
    options = EntityLevel.XML;
  }

  var opts = typeof options === "number" ? {
    level: options
  } : options; // Mode `UTF8` just escapes XML entities

  if (opts.mode === EncodingMode.UTF8) return (0, escape_js_1.escapeUTF8)(data);
  if (opts.mode === EncodingMode.Attribute) return (0, escape_js_1.escapeAttribute)(data);
  if (opts.mode === EncodingMode.Text) return (0, escape_js_1.escapeText)(data);

  if (opts.level === EntityLevel.HTML) {
    if (opts.mode === EncodingMode.ASCII) {
      return (0, encode_js_1.encodeNonAsciiHTML)(data);
    }

    return (0, encode_js_1.encodeHTML)(data);
  } // ASCII and Extensive are equivalent


  return (0, escape_js_1.encodeXML)(data);
}

exports.encode = encode;

var escape_js_2 = require("./escape.js");

Object.defineProperty(exports, "encodeXML", {
  enumerable: true,
  get: function get() {
    return escape_js_2.encodeXML;
  }
});
Object.defineProperty(exports, "escape", {
  enumerable: true,
  get: function get() {
    return escape_js_2.escape;
  }
});
Object.defineProperty(exports, "escapeUTF8", {
  enumerable: true,
  get: function get() {
    return escape_js_2.escapeUTF8;
  }
});
Object.defineProperty(exports, "escapeAttribute", {
  enumerable: true,
  get: function get() {
    return escape_js_2.escapeAttribute;
  }
});
Object.defineProperty(exports, "escapeText", {
  enumerable: true,
  get: function get() {
    return escape_js_2.escapeText;
  }
});

var encode_js_2 = require("./encode.js");

Object.defineProperty(exports, "encodeHTML", {
  enumerable: true,
  get: function get() {
    return encode_js_2.encodeHTML;
  }
});
Object.defineProperty(exports, "encodeNonAsciiHTML", {
  enumerable: true,
  get: function get() {
    return encode_js_2.encodeNonAsciiHTML;
  }
}); // Legacy aliases (deprecated)

Object.defineProperty(exports, "encodeHTML4", {
  enumerable: true,
  get: function get() {
    return encode_js_2.encodeHTML;
  }
});
Object.defineProperty(exports, "encodeHTML5", {
  enumerable: true,
  get: function get() {
    return encode_js_2.encodeHTML;
  }
});

var decode_js_2 = require("./decode.js");

Object.defineProperty(exports, "EntityDecoder", {
  enumerable: true,
  get: function get() {
    return decode_js_2.EntityDecoder;
  }
});
Object.defineProperty(exports, "DecodingMode", {
  enumerable: true,
  get: function get() {
    return decode_js_2.DecodingMode;
  }
});
Object.defineProperty(exports, "decodeXML", {
  enumerable: true,
  get: function get() {
    return decode_js_2.decodeXML;
  }
});
Object.defineProperty(exports, "decodeHTML", {
  enumerable: true,
  get: function get() {
    return decode_js_2.decodeHTML;
  }
});
Object.defineProperty(exports, "decodeHTMLStrict", {
  enumerable: true,
  get: function get() {
    return decode_js_2.decodeHTMLStrict;
  }
});
Object.defineProperty(exports, "decodeHTMLAttribute", {
  enumerable: true,
  get: function get() {
    return decode_js_2.decodeHTMLAttribute;
  }
}); // Legacy aliases (deprecated)

Object.defineProperty(exports, "decodeHTML4", {
  enumerable: true,
  get: function get() {
    return decode_js_2.decodeHTML;
  }
});
Object.defineProperty(exports, "decodeHTML5", {
  enumerable: true,
  get: function get() {
    return decode_js_2.decodeHTML;
  }
});
Object.defineProperty(exports, "decodeHTML4Strict", {
  enumerable: true,
  get: function get() {
    return decode_js_2.decodeHTMLStrict;
  }
});
Object.defineProperty(exports, "decodeHTML5Strict", {
  enumerable: true,
  get: function get() {
    return decode_js_2.decodeHTMLStrict;
  }
});
Object.defineProperty(exports, "decodeXMLStrict", {
  enumerable: true,
  get: function get() {
    return decode_js_2.decodeXML;
  }
});